// extracted by mini-css-extract-plugin
export default {"content":"src-containers-layouts-content-styles-content-Nb4-s"};